import { Selector } from "@ngxs/store";
import { AuthState, AuthStateModel } from "./auth.state";

export class AuthSelectors {
  @Selector([AuthState])
  static token(state: AuthStateModel): string {
    return state.token;
  }

  @Selector([AuthState])
  static getIsLoading(state: AuthStateModel) : boolean {
    return state.isLoading;
  }

  @Selector([AuthState])
  static getUserName(state: AuthStateModel): string {
    return state.userName;
  }

  @Selector([AuthState])
  static getUser(state: AuthStateModel): string {
    return state.user;
  }

  @Selector([AuthState])
  static getLevel(state: AuthStateModel): number {
    return state.level;
  }

  @Selector([AuthState])
  static isAuthenticated(state: AuthStateModel): boolean {
    return !!state.token;
  }

  @Selector([AuthState])
  static getError(state: AuthStateModel): string {
    return state.error;
  }
}
